/**
 * The 24 official Tunisian governorates (PDF §27): "structure d'adresse
 * incluant gouvernorat et délégation comme champs structurés (liste
 * officielle des 24 gouvernorats tunisiens), plutôt qu'un simple champ
 * libre."
 *
 * This is fixed public geographic data, not a business decision, so listing
 * it here is not "inventing a requirement".
 *
 * Delegations, one level below, live in `delegations.ts` (keyed by these codes), from the INS 2024 census list.
 */
export interface Governorate {
  readonly code: string;
  readonly nameFr: string;
  readonly nameAr: string;
}

export const GOVERNORATES: readonly Governorate[] = [
  { code: 'TUN', nameFr: 'Tunis', nameAr: 'تونس' },
  { code: 'ARI', nameFr: 'Ariana', nameAr: 'أريانة' },
  { code: 'BEN', nameFr: 'Ben Arous', nameAr: 'بن عروس' },
  { code: 'MAN', nameFr: 'Manouba', nameAr: 'منوبة' },
  { code: 'NAB', nameFr: 'Nabeul', nameAr: 'نابل' },
  { code: 'ZAG', nameFr: 'Zaghouan', nameAr: 'زغوان' },
  { code: 'BIZ', nameFr: 'Bizerte', nameAr: 'بنزرت' },
  { code: 'BEJ', nameFr: 'Béja', nameAr: 'باجة' },
  { code: 'JEN', nameFr: 'Jendouba', nameAr: 'جندوبة' },
  { code: 'KEF', nameFr: 'Le Kef', nameAr: 'الكاف' },
  { code: 'SIL', nameFr: 'Siliana', nameAr: 'سليانة' },
  { code: 'KAI', nameFr: 'Kairouan', nameAr: 'القيروان' },
  { code: 'KAS', nameFr: 'Kasserine', nameAr: 'القصرين' },
  { code: 'SBZ', nameFr: 'Sidi Bouzid', nameAr: 'سيدي بوزيد' },
  { code: 'SOU', nameFr: 'Sousse', nameAr: 'سوسة' },
  { code: 'MON', nameFr: 'Monastir', nameAr: 'المنستير' },
  { code: 'MAH', nameFr: 'Mahdia', nameAr: 'المهدية' },
  { code: 'SFA', nameFr: 'Sfax', nameAr: 'صفاقس' },
  { code: 'GAF', nameFr: 'Gafsa', nameAr: 'قفصة' },
  { code: 'TOZ', nameFr: 'Tozeur', nameAr: 'توزر' },
  { code: 'KEB', nameFr: 'Kébili', nameAr: 'قبلي' },
  { code: 'GAB', nameFr: 'Gabès', nameAr: 'قابس' },
  { code: 'MED', nameFr: 'Médenine', nameAr: 'مدنين' },
  { code: 'TAT', nameFr: 'Tataouine', nameAr: 'تطاوين' },
] as const;

const BY_CODE = new Map(GOVERNORATES.map((g) => [g.code, g]));

export function governorateByCode(code: string): Governorate | undefined {
  return BY_CODE.get(code);
}

export function isValidGovernorateCode(code: string): boolean {
  return BY_CODE.has(code);
}
